export const Smedia = [
    // {type: 'image', url: require('../../../assets/Sweta_mishra/3.webp')},
    {type: 'image', url: require('../../../assets/shweta_mishra/4.webp')},
    {type: 'image', url: require('../../../assets/shweta_mishra/5.webp')},
    {type: 'image', url: require('../../../assets/shweta_mishra/7.webp')},
    {type: 'image', url: require('../../../assets/shweta_mishra/1.webp')},
    {type: 'image', url: require('../../../assets/shweta_mishra/2.webp')},
    {type: 'image', url: require('../../../assets/shweta_mishra/3.webp')},
    {type: 'image', url: require('../../../assets/shweta_mishra/6.webp')},
    {type: 'image', url: require('../../../assets/shweta_mishra/8.webp')},
    {type: 'image', url: require('../../../assets/shweta_mishra/9.jpg')},
]